import { render, staticRenderFns } from "./showContent.vue?vue&type=template&id=7506765d&scoped=true"
import script from "./showContent.vue?vue&type=script&lang=ts"
export * from "./showContent.vue?vue&type=script&lang=ts"
import style0 from "./showContent.vue?vue&type=style&index=0&id=7506765d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506765d",
  null
  
)

export default component.exports